<template>
	<div class="empty-panel">
		<div class="empty-icon">
			<img src="@/assets/images/empty.png" alt="" />
		</div>
		<div class="et-label">
			{{$t('暂无记录')}}
		</div>
	</div>
</template>

<script>
	export default {
		data: function() {
			return {}
		},
		methods: {
		},
	}
</script>
<style scoped>
	.empty-panel{
		height: 60vh;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		text-align: center;
	}
	.empty-icon{
		font-size: 0;
	}
	.et-label{
		text-align: center;
		margin-top: 16px;
		color: #999;
	}

</style>